import React from 'react';
import {connect} from 'react-redux';
import {GeneralContent, Incidents, Status, Systems} from '../Redux/ContentfulContentGrabber';
import '../CSS/App.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {Card, CardTitle, CardText} from 'material-ui/Card';
import {MuiThemeProvider} from "material-ui";
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Moment from 'moment';
import ShowMoreText from 'react-show-more-text';
import ReactMarkdown from 'react-markdown';

class HistoricalIssuesComponent extends React.Component {

    componentWillMount() {
        //Gathers all the contentful data from Redux
        this.props.fetchData();
        this.props.fetchSystemData();
        this.props.fetchIncidentsData();
    }

    //Scrolls to the top of an issues card when the user minimizes the "Read More" button
    static handleScrollToElement(i) {
        let offsets = document.getElementById(i).getBoundingClientRect();
        let top = offsets.top;
        window.scrollBy(0, top - 80);
    }

    getSystemRowsFromContentful() {
        //This gets the list of all systems, i.e. Oracle, POS etc.
        let listOfAllSystemStatuses = [];
        for (let i = 0; i < this.props.systems.items.length; i++) {
            listOfAllSystemStatuses.push(this.props.systems.items[i].fields.name.toString());
        }
        return listOfAllSystemStatuses;
    }

    static sortStatusListByStatusLevel(unorderedStatus) {
        return unorderedStatus.sort(function (a, b) {
            return a[2] < b[2] ? 1 : -1;
        });
    }


    getIncidentList() {
        let unorderedSystemsListFromContentful = this.getSystemRowsFromContentful();
        let orderedSystemsListFromContentful = HistoricalIssuesComponent.sortStatusListByStatusLevel(unorderedSystemsListFromContentful);
        return this.createIncidentListArrays(orderedSystemsListFromContentful);
    }

    createIncidentListArrays(orderedSystemsListFromContentful) {
        let incidentList = [];
        for (let i = 0; i < orderedSystemsListFromContentful.length; i++) {
            let incidentsForEachSystem = [];
            incidentList.push(incidentsForEachSystem);
        }

        for (let i = 0; i < this.props.incidents.items.length; i++) {
            for (let x = 0; x < orderedSystemsListFromContentful.length; x++) {
                if (orderedSystemsListFromContentful[x].toString() === this.props.incidents.items[i].fields.system.fields.name.toString()) {
                    incidentList[x].push(this.props.incidents.items[i]);
                }
            }
        }
        return incidentList;
    }

    getAlerts(incidents) {
        //If incident is resolved then it should not go at the top as an alert, this method sorts resolved
        //an unresolved incidents
        let alert = [];
        let sortedAlert;
        let sortedCreateAlert = [];
        for (let i = 0; i < incidents.length; i++) {
            let incidentsPerSystem = incidents[i];
            for (let x = 0; x < incidentsPerSystem.length; x++) {
                if (HistoricalIssuesComponent.isIncidentResolvedYet(incidentsPerSystem[x])) {
                    alert.push(
                        incidentsPerSystem[x]
                    );
                }
            }
        }
        sortedAlert = HistoricalIssuesComponent.sortAlertsByResolutionDate(alert);

        //This method has a limit of 20 meaning that it will max show 20 historical alerts
        for (let i = 0; i < Math.min(sortedAlert.length, 20); i++) {
            sortedCreateAlert.push(this.createAlert(sortedAlert[i], i))
        }
        return sortedCreateAlert;
    }

    static sortAlertsByResolutionDate(alerts) {
        return alerts.sort(function (a, b) {
            return a.fields.resolveDate < b.fields.resolveDate ? 1 : -1;
        });
    }

    static isIncidentResolvedYet(incident) {
        return incident.fields.resolved !== false;
    }

    createAlert(incident, i) {
        Moment.locale('en');
        let systemName = incident.fields.system.fields.name.toString();
        let incidentDescription = incident.fields.incidentDescription.toString();
        let incidentStatus = incident.fields.status.fields.statusName.toString();
        let openedDate = Moment(incident.fields.openDate).format('MMM D, YYYY');
        let openedTime = Moment(incident.fields.openDate).format('hh:mm A');

        //If the resolved data and time are not found, this is the fallback
        let resolvedDate = "N/A";
        let resolvedTime = "";
        if (typeof(incident.sys.updatedAt) !== "undefined") {
            resolvedDate = Moment(incident.sys.updatedAt).format('MMM D, YYYY');
            resolvedTime = "- " + Moment(incident.sys.updatedAt).format('hh:mm A') + " EST";
        }
        if (typeof(incident.fields.resolveDate) !== "undefined") {
            resolvedDate = Moment(incident.fields.resolveDate).format('MMM D, YYYY');
            resolvedTime = "- " + Moment(incident.fields.resolveDate).format('hh:mm A') + " EST";
        }

        return (
            <Card className={"cards"} id={i}
                  style={{boxShadow: "none", borderStyle: "solid", borderWidth: 1, borderColor: "#E8E8E8"}}
                  ref={(section) => {
                      this.header = section;
                  }}>
                <CardTitle title={<div className={"fontBoldLarge"}
                                       style={{color: "#5A5B68"}}>{systemName} - {incidentStatus}</div>}
                           subtitle={<div className="fontRegularSmall">Opened: {openedDate} - {openedTime} EST</div>}
                           style={{paddingLeft: "20px", paddingRight: "20px"}}
                />
                <CardText style={{paddingTop: "10px", paddingLeft: "20px", paddingRight: "20px"}}>
                    <div className={"statusTextTable"}>
                        <ShowMoreText
                            lines={3}
                            more={<div className={"showMoreButton"}><b>Show more</b></div>}
                            less={<div className={"showMoreButton"} onClick={() => HistoricalIssuesComponent.handleScrollToElement(i)}><b>Show
                                less</b></div>}
                            anchorClass=''>
                            <ReactMarkdown className={"fontRegularMedium"} source={incidentDescription}/>
                        </ShowMoreText>
                        <div className={"resolvedText"}>
                            Resolved: {resolvedDate} {resolvedTime}
                        </div>
                    </div>
                </CardText>
            </Card>
        );
    }

    isContentfulContentAvailableYet() {
        return !Array.isArray(this.props.systems) && !Array.isArray(this.props.incidents) && !Array.isArray(this.props.generalContent);
    }

    render() {
        if (this.isContentfulContentAvailableYet()) {
            let incidents = this.getIncidentList();
            let alerts = this.getAlerts(incidents);
            if (alerts.length > 0) {
                return (
                    <ReactCSSTransitionGroup
                        transitionName="example"
                        transitionAppear={true}
                        transitionAppearTimeout={50000}
                        transitionEnter={false}
                        transitionLeave={false}>
                        <h1 className="fontBoldLarge headerTitle mostRecent">Most Recent</h1>
                        <MuiThemeProvider muiTheme={getMuiTheme()}>
                            {alerts}
                        </MuiThemeProvider>
                    </ReactCSSTransitionGroup>
                );
            }
        }
        return (null)
    }

}

//Redux, gathers all Contentful Data
const mapStateToProps = (state) => {
    return {
        generalContent: state.generalContent,
        systems: state.systems,
        incidents: state.incidents,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading
    };
};

//Redux, gathers all Contentful Data
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => dispatch(GeneralContent()),
        fetchSystemData: () => dispatch(Systems()),
        fetchIncidentsData: () => dispatch(Incidents())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoricalIssuesComponent);



// WEBPACK FOOTER //
// ./src/Components/HistoricalIssuesComponent.js